import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import React, { Fragment } from "react";
import Cabecalho from "../cabecalho/Cabecalho";
import Rodape from "../rodape/Rodape";
// import Grid from "@material-ui/core/Grid";

import IconButton from "@material-ui/core/IconButton";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import BusinessCenterOutlinedIcon from "@material-ui/icons/BusinessCenterOutlined";

import Tooltip from "@material-ui/core/Tooltip";
import MonitorHeartIcon from "@material-ui/icons/AccessAlarms";
import Apartment from "@material-ui/icons/Apartment";
import Assessment from "@material-ui/icons/Assessment";
import Compare from "@material-ui/icons/Compare";
import Dashboard from "@material-ui/icons/Dashboard";
import ExitToApp from "@material-ui/icons/ExitToApp";
import LineStyle from "@material-ui/icons/LineStyle";
import LockOpen from "@material-ui/icons/LockOpen";
import QueryBuilder from "@material-ui/icons/QueryBuilder";
import ShutterSpeed from "@material-ui/icons/ShutterSpeed";
import AddRoadIcon from "@mui/icons-material/AddRoad";
import AppsOutage from "@mui/icons-material/AppsOutage";


import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { AuthContext } from "../../App";

const useStyles = makeStyles((theme) => ({
    root: {
        height: "100vh",
        width: "100vw",
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    main_grid: {
        width: "100%",
        alignItems: "center",
        height: "100vh",
        flex: 1,
    },
    header: {
        display: "flex",
        justifyContent: "center",
    },
    footer: {
        marginTop: "auto",
    },
    sideBar: {
        position: "fixed",
        width: "3vw",
        marginTop: "8vh",
    },
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100vh",
    },
    content: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        textAlign: "center",
        position: "relative",
    },
    paper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    },
    showButton: {
        display: "inline",
    },
    hideButton: {
        display: "none",
    },
}));

export function Pagina(props) {
    const classes = useStyles();
    let history = useHistory();
    const { dispatch } = React.useContext(AuthContext);

    const logOut = () => {
        console.log("Logout ");
        dispatch({ type: "LOGOUT" });
        history.push("/");
    };

    function verificaPrivilegio(privilegio) {
        let i = 0;
        for (i; i < props.authState.features.length; i++) {
            let permissao = props.authState.features[i];
            if (permissao === privilegio) {
                return true;
            }
        }
    }

    return (
        <Fragment>
            <CssBaseline />
            <div container component="main" className={classes.root} spacing={3}>
                <div className={classes.main_grid}>
                    <div className={classes.header}>
                        <Cabecalho
                            name={props.authState.name}
                            HeaderDesc={props.HeaderDesc}
                        />
                    </div>
                    <div className={classes.container}>
                        <div className={classes.content}>
                            <props.Content />
                        </div>
                    </div>
                </div>
                <div className={classes.sideBar}>
                    <Paper className={classes.paper}>
                        <Tooltip title="Dashboard">
                            <IconButton
                                color="secondary"
                                onClick={() => {
                                    history.push("/");
                                }}
                                className={
                                    verificaPrivilegio("/")
                                        ? classes.showButton
                                        : classes.hideButton
                                }
                            >
                                <Dashboard />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Monitoração">
                            <IconButton
                                color="secondary"
                                onClick={() => {
                                    history.push("/monitoracao");
                                }}
                                className={
                                    verificaPrivilegio("/monitoracao")
                                        ? classes.showButton
                                        : classes.hideButton
                                }
                            >
                                <MonitorHeartIcon />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Container Upload">
                            <IconButton
                                color="secondary"
                                onClick={() => {
                                    history.push("/situacaoupload");
                                }}
                                className={
                                    verificaPrivilegio("/situacaoupload")
                                        ? classes.showButton
                                        : classes.hideButton
                                }
                            >
                                <AddRoadIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Falta Diretório">
                            <IconButton
                                color="secondary"
                                onClick={() => {
                                    history.push("/missingdirectory");
                                }}
                                className={
                                    verificaPrivilegio("/missingdirectory")
                                        ? classes.showButton
                                        : classes.hideButton
                                }
                            >
                                <AppsOutage />
                            </IconButton>
                        </Tooltip>


                        <Tooltip title="Manutenção de Cliente">
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    history.push("/cliente");
                                }}
                                className={
                                    verificaPrivilegio("/cliente")
                                        ? classes.showButton
                                        : classes.hideButton
                                }
                            >
                                <BusinessCenterOutlinedIcon />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Manutenção de Usuário">
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    history.push("/usuario");
                                }}
                                className={
                                    verificaPrivilegio("/usuario")
                                        ? classes.showButton
                                        : classes.hideButton
                                }
                            >
                                <AssignmentInd />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Manutenção de Site">
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    history.push("/site");
                                }}
                                className={
                                    verificaPrivilegio("/site")
                                        ? classes.showButton
                                        : classes.hideButton
                                }
                            >
                                <Apartment />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Importação Reanalise">
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    history.push("/reanalise");
                                }}
                                className={
                                    verificaPrivilegio("/reanalise")
                                        ? classes.showButton
                                        : classes.hideButton
                                }
                            >
                                <ShutterSpeed />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Trocar senha">
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    history.push("/trocasenha");
                                }}
                                className={
                                    verificaPrivilegio("/trocasenha")
                                        ? classes.showButton
                                        : classes.hideButton
                                }
                            >
                                <LockOpen />
                            </IconButton>
                        </Tooltip>

                        <div className={classes.clearIndicator}>
                            <Tooltip title="Listar Containers">
                                <IconButton
                                    color="primary"
                                    onClick={() => {
                                        history.push("/listarcontainer");
                                    }}
                                    className={
                                        verificaPrivilegio("/listarcontainer")
                                            ? classes.showButton
                                            : classes.hideButton
                                    }
                                >
                                    <LineStyle />
                                </IconButton>
                            </Tooltip>
                        </div>

                        <Tooltip title="Consultar">
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    history.push("/consultar");
                                }}
                                className={
                                    verificaPrivilegio("/consultar")
                                        ? classes.showButton
                                        : classes.hideButton
                                }
                            >
                                <QueryBuilder />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Analisar">
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    history.push("/analisar");
                                }}
                                className={
                                    verificaPrivilegio("/analisar")
                                        ? classes.showButton
                                        : classes.hideButton
                                }
                            >
                                <Assessment />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="KPI">
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    history.push("/kpi");
                                }}
                                className={
                                    verificaPrivilegio("/kpi")
                                        ? classes.showButton
                                        : classes.hideButton
                                }
                            >
                                <Compare />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Sair">
                            <IconButton color="primary" onClick={logOut}>
                                <ExitToApp />
                            </IconButton>
                        </Tooltip>
                    </Paper>
                </div>

                <div className={classes.footer}>
                    <Paper className={classes.paper}>
                        <Rodape />
                    </Paper>
                </div>
            </div>
        </Fragment>
    );
}
